import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { apiAccessRequestAPI } from '../../../api';

import {convertToDate} from '../../../utils'

import {Modal} from '../../../components/Modal'

interface Props {
  request: any
  show: boolean
  handleClose: () => void
  handleUpdated: () => void
}

const schema = Yup.object().shape({
  status: Yup.string().required('Required'),
});

const REJECT_COMMENT = 'The information provided is insufficient. Kindly resubmit your request with the necessary details.'

const APIAccessRequestReviewModal : React.FC<Props> = ({request, show, handleClose, handleUpdated}) => {

  const [handling, setHandling] = useState(false)

  const formik = useFormik({
    initialValues: {'status': '', 'review_comment': ''},
    validationSchema: schema,
    onSubmit: async (values) => {
      setHandling(true)
      try{
        await apiAccessRequestAPI.updateStatus(request.id, values['status'], values['review_comment'])
        handleUpdated()
        formik.resetForm()
        handleClose()
      } finally {
        setHandling(false)
      }
    }
  })


  useEffect(() => {
    if (formik.values.status === 'rejected' && !formik.values.review_comment){
      formik.setFieldValue('review_comment', REJECT_COMMENT);
    }else if (formik.values.review_comment === REJECT_COMMENT ) {
      formik.setFieldValue('review_comment', '');
    }
  }, [formik.values.status]);


  return <Modal show={show} handleClose={handleClose} dialogClassName="" title={'Review'}>
    <form
      className='form fv-plugins-bootstrap5 fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    > 
      {request.created_by_email && 
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Created By (Admin)</label>
        <div>{request.created_by_email}</div>
      </div>
      }
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Requested On</label>
        <div>{convertToDate(request.created_dt)}</div>
      </div>
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Full Name</label>
        <div>{request.full_name}</div>
      </div>
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Email</label>
        <div>{request.email}</div>
      </div>
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Organization</label>
        <div>{request.organization}</div>
      </div>
      <div className='fv-row mb-5'>
        <label className='form-label fs-6 text-gray-600'>Use Case</label>
        <div>{request.use_case}</div>
      </div>
      <div className="separator my-5"></div>
      <div className='fv-row mb-5 form-floating'>
        <select
          className={clsx(
            'form-select bg-transparent',
            {'is-invalid': formik.touched.status && formik.errors.status},
            {
              'is-valid': formik.touched.status && !formik.errors.status,
            }
          )}
          data-kt-select2='true'
          data-placeholder='Select Status'
          data-allow-clear='true'
          data-hide-search='true'
          {...formik.getFieldProps('status')}
        >
          <option value=''></option>
          { [['approved', 'Approve'],['rejected', 'Reject']].map((status, index) => {
            return (
              <option key={index} value={status[0]}>{status[1]}</option>
            )
          })}
        </select>
        <label className='form-label fs-6 text-gray-600'>Status</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="review_comment"
          {...formik.getFieldProps('review_comment')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.review_comment && formik.errors.review_comment},
            {
              'is-valid': formik.touched.review_comment && !formik.errors.review_comment,
            }
          )}
          type='text'
          name='review_comment'
        />
        <label className='form-label fs-6 text-gray-600'>Comment</label>
      </div>
      <div className="text-center">
        <button
          type='submit'
          className="btn btn-primary"
          disabled={handling || !formik.isValid}
        >
          {!handling && <span className='indicator-label'>Submit</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        
        <button type="button" className="btn btn-light ms-3" onClick={handleClose}>
          Close
        </button>
      </div>
    </form>
  </Modal>
}

export {APIAccessRequestReviewModal}